import "firebase/firestore";
import announcements from "@/frame/messages/mixins/announcements.js";
import dataSources from "@/data/cloud/firebase/mixins/dataSources.js";
import btnControl from "@/frame/animation/mixins/btnControl.js";
import docRevsFunctions from "@/document/revisions/mixins/docRevsFunctions.js";
import docLogFunctions from "@/document/log/mixins/docLogFunctions.js";
import generateLog from "@/document/log/mixins/generateLog.js";
import accessFunctions from "@/support/access/mixins/accessFunctions.js";
import listFunctions from "@/data/functions/mixins/listFunctions.js";
import changeFirebase from "@/data/cloud/firebase/mixins/changeFirebase.js";
import describeDocument from "@/data/describe/mixins/describeDocument";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import generateRelps from "@/data/functions/mixins/generateRelps.js";
import statsFunctions from "@/data/functions/mixins/statsFunctions.js";
import relpsFunctions from "@/data/functions/mixins/relpsFunctions.js";
import workCallFunctions from "@/work/call/mixins/workCallFunctions.js";
import relps from "@/data/forms/mixins/relps.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import generateRoles from "@/support/roles/mixins/generateRoles.js";
import statsMods from "@/support/stats/mixins/statsMods.js";
import { mapGetters } from "vuex";

export default {
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getUserAccessList",
      "getDocumentLog",
      "getOriginal",
      "getBudgetDID",
      "getMaterialDID",
      "getMaintStrategyDID",
      "getAssetRegister",
      "getSearchResults",
      "getSearchResultsCounter"
    ])
  },
  data() {
    return {
      dbEmpty: false,
      duplicate: false,
      searchLimitDuplicateCheck: 10000
    };
  },
  mixins: [
    relps,
    btnControl,
    dataSources,
    announcements,
    docRevsFunctions,
    docLogFunctions,
    accessFunctions,
    listFunctions,
    changeFirebase,
    describeDocument,
    displayFunctions,
    numberFunctions,
    apptheme,
    generateLog,
    generateRelps,
    statsFunctions,
    relpsFunctions,
    generateRoles,
    workCallFunctions,
    statsMods
  ],
  methods: {
    archiveFirebaseDocument(doc) {
      // database and address
      let did = doc.basic.did; // address
      let tag = doc.basic.tag;
      let dbCreate = this.defineDataSourceFromTagForArchive(tag);
      let dbDelete = this.defineDataSourceFromTag(tag);
      // change doc
      let tempDOC = doc;
      tempDOC.basic.ver = "A"; // "A for archive"

      // HELP
      console.log("");
      console.log("ARCHIVE FIREBASE DOCUMENT");
      console.log("TAG:        " + tag);
      console.log("DID:        " + did);
      console.log("TITLE:      " + doc.basic.title);
      console.log("DB CREATE : ");
      console.log(dbCreate);
      console.log("DB DELETE : ");
      console.log(dbDelete);
      console.log("DOC:        ");
      console.log(doc);

      // SAVE (Create Duplicate)
      // eslint-disable-next-line
      dbCreate.doc(did).set(tempDOC).then(() => {
          // REMOVED SEARCH LIST
          this.removeItemFromSearchResults(doc);
          // DELETE
          dbDelete.doc(did).delete();
        })
        .then(() => {
          // DELETE (2nd as sometimes first attempt is not working)
          dbDelete.doc(did).delete();
        })
        .then(() => {
          // REMOVE from SERACH RESULTS
          // this.addNewToSearchResults(doc);
          let tagMsg = doc.basic.tag;
          let msg = "Archived ";
          msg = msg + this.defineDocumentFromTag(tagMsg).title;
          msg = msg + " ";
          msg = msg + this.displayDocumentIDGTypeA(tag, doc.basic.idg) + " ";
          msg = msg + doc.basic.title + "";
          msg = msg + ".";
          this.generateInfoSnackbar(this.ui.colorBlue1, msg);
          // STOP BTN SPIN
          this.stopBtnSpinAll();
          // CLOSE
          this.dialog = false;
          // GO to SEARCH
          this.$router.push("/registerlist");
        });
    },
    removeItemFromSearchResults(item) {
      // DEFINE
      let tag = item.basic.tag;
      let temp = item;
      temp.basic.list = true; // recently accessed idnicator
      temp.basic.save = true; // save availablke
      // UPDATE EMEDDED LIST which if the list is ACTIVE
      // eslint-disable-next-line
      if (this.getSearchResults !== null && this.getSearchResults !== undefined) {
        if (this.getSearchResults.length > 0) {
          let tagResult = this.getSearchResults[0].basic.tag;
          if (tagResult === tag) {
            // LIST UPDATE
            var tempList = this.getSearchResults;
            var obj = Object.assign({}, temp);
            var parseobj = JSON.parse(JSON.stringify(obj));
            var newList = this.removeItemReturnListCheckDID(parseobj, tempList);
            // var newList = tempList.push(obj);
            this.$store.dispatch("changeSearchResults", newList);
            // eslint-disable-next-line
            this.$store.dispatch("changeSearchResultsCounter", this.getSearchResultsCounter + 1);

            // console.log(newList);
            this.dialog = false;
            this.stopBtnSpinAll();
            // UPDATE LIST
            console.log("");
            console.log(">>> SEARCH RESULTS NEW ITEM REMOVED <<<");
            console.log("TAG   : " + tag);
            console.log("TITLE : " + temp.basic.title);
            console.log("DID   : " + temp.basic.did);
            console.log("DOC   : ");
            console.log(temp);
            console.log(newList);
          }
        }
      }
    }
  }
};
